// Defines a windowed area for where new pages can be rendered with existing templates

import React from 'react';
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import { useLiveUpdateProvider } from './provider';
import { useTemplateProvider } from '../../contexts/template-provider';
import { PageTemplate } from '../../utils/match-page-template';

const LiveUpdateWindow: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const { isPreview, isFromMicrosite } = useLiveUpdateProvider();
    const { template } = useTemplateProvider();
    const { pathname } = useLocation();

    React.useEffect(() => {
        if (
            isPreview
            && isFromMicrosite
            && (template !== PageTemplate.MicrositePage && template !== PageTemplate.MicrositeService)
        ) {
            navigate(`/locations/tn/servpro-of-sumner-county${pathname}`);
        }
    }, [isPreview, isFromMicrosite, template, pathname]);

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>{children}</>
    );
};

export default LiveUpdateWindow;
